import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React from "react";
import localeText from "../../locale";
import Loading from "../Loading/Loading";

const CreateFinancialPasswordModal = ({
  setModalNotVisible,
  isVisible,
  canCreateFinancialPassword,
  isLoadingCreateFinancialPassword,
  createFinantialPassword,
  isFirstPassword = false,
}) => {
  const handleCloseModal = () => {
    setModalNotVisible();
    localStorage.setItem("__extraconomy_hasToCheckFinantialPassword__", "false");
  };

  return (
    <>
      {canCreateFinancialPassword && (
        <Dialog
          header={
            isFirstPassword
              ? localeText("youDonthaveFinancialPassword")
              : localeText("youAlreadyHaveAFinancialPassword")
          }
          visible={isVisible}
          className="w-30rem m-2"
          onHide={() => {
            if (!isLoadingCreateFinancialPassword) handleCloseModal();
          }}
          draggable={false}
        >
          <div className="flex flex-column gap-4">
            <p className="m-0">
              {isFirstPassword
                ? localeText("wantCreateFinancialPassword")
                : localeText("youWantToCreateNewFinancialPassword")}
            </p>
            <div className="flex gap-2 justify-content-end">
              <Button
                onClick={handleCloseModal}
                severity="danger"
                disabled={isLoadingCreateFinancialPassword}
              >
                {localeText("no")}
              </Button>
              <Button
                onClick={() => createFinantialPassword(setModalNotVisible)}
                disabled={isLoadingCreateFinancialPassword}
                className={`${isLoadingCreateFinancialPassword ? "opacity-80" : ""}`}
              >
                <div className="flex justify-content-center align-items-center gap-2">
                  {isLoadingCreateFinancialPassword && (
                    <Loading classNameIcon={"text-sm"} disableMargin />
                  )}
                  <p>{localeText("yes")}</p>
                </div>
              </Button>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default CreateFinancialPasswordModal;
